import React, { JSX } from "react";

const CustomHeader = ({ imageUrl }: { imageUrl: string }): JSX.Element => (
  <img
    src={imageUrl}
    alt="custom-header"
    style={{
      border: "1px dashed #ddd",
      objectFit: "cover",
      width: "100%"
    }}
  />
);

export default CustomHeader;
